@if (screenvalue==999) {
  <div class="landingcontainer">
    <div class="reviewbox">
      <div class="reviewdetails">
        <div class="reviewimage">
          <img  [src]="getImage(landingcontent?.UptakeImg1)">
        </div>
        <div class="reviewtext" [innerHtml]="landingcontent?.headline">
        </div>
      </div>
      <div class="spiltline"></div>
      <div class="reviewdetails">
        <div class="reviewimage">
          <img  [src]="getImage(landingcontent?.UptakeImg2)">
        </div>
        <div class="reviewtext" [innerHtml]="landingcontent?.h2content">
        </div>
      </div>
      <div class="spiltline"></div>
      <div class="reviewdetails">
        <div class="reviewimage">
          <img  [src]="getImage(landingcontent?.UptakeImg3)">
        </div>
        <div class="reviewtext" [innerHtml]="landingcontent?.h3content">
        </div>
      </div>
    </div>
    <div class="cardsection">
      <div class="eachcard">
        <div>
          <div [innerHtml]="landingcontent?.text1"></div>
          <div class="cardimage"><img [src]="getImage(landingcontent?.UptakeImg4)"></div>
          <div [innerHtml]="landingcontent?.largeparagraphcontent"></div>
        </div>
        <div [innerHtml]="landingcontent?.LargeText1"></div>
        <div class="resourcebtn" (click)="navigatetodetails(1)">View Resource</div>
      </div>
      <div class="eachcard">
        <div>
          <div [innerHtml]="landingcontent?.text2"></div>
          <div class="cardimage"><img [src]="getImage(landingcontent?.media)"></div>
          <div [innerHtml]="landingcontent?.materialCode"></div>
        </div>
        <div [innerHtml]="landingcontent?.LargeText2"></div>
        <div class="resourcebtn" (click)="navigatetodetails(2)">View Resource</div>
      </div>
      <div class="eachcard">
        <div>
          <div [innerHtml]="landingcontent?.text3"></div>
          <div class="cardimage"><img [src]="getImage(landingcontent?.picture2)"></div>
          <div [innerHtml]="landingcontent?.content"></div>
        </div>
        <div [innerHtml]="landingcontent?.LargeText3"></div>
        <div class="resourcebtn" (click)="navigatetodetails(3)">View Resource</div>
      </div>
    </div>
    <div class="reference" [innerHtml]="landingcontent?.reference"></div>
    <div  class="uptk_Disclaimer" [innerHTML]="landingcontent?.paragraphcontent"></div>
  </div>
}
